// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"dae40afe","353":"891c295e"}[chunkId] + ".js";
};